import { render } from "./BarComponent.vue?vue&type=template&id=97e2ac54&ts=true"
import script from "./BarComponent.vue?vue&type=script&lang=ts"
export * from "./BarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__